<template>

  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="formInline.search" clearable placeholder="请输入内容关键词"></el-input></el-form-item>
        <el-form-item label="反馈时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.time_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    <!-- <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addSuggestion">添加素材</el-button></div> -->
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="suggestion_id" label="记录id" width="60"></el-table-column>
        <el-table-column  label="反馈用户" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.user_id">{{scope.row.user.nickName}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="address" label="用户头像" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.user_id" v-img-url="scope.row.user.avatarUrl" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="content" label="反馈内容" >
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.content">{{scope.row.content}}</div>
          </template>
        </el-table-column>
        
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="green">已处理</span>
            <span v-if="scope.row.status == 0" class="gray">未处理</span>
          </template>
        </el-table-column>

        <el-table-column prop="create_time" label="反馈时间" width="140"></el-table-column>
        <el-table-column prop="name" label="操作" width="90">
          <template slot-scope="scope">
            <el-button @click="editSuggestion(scope.row)" type="text" size="small">查看详情</el-button>

            <el-button @click="deleteSuggestion(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination
           @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
         background :current-page="curPage" 
         :page-size="pageSize" 
         layout="total, prev, pager, next, jumper" 
         :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SuggestionApi from '@/api/suggestion.js';
export default {
  components: {},
  data() {
    return {
      /*分类*/
      categoryData: [],
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      formInline: {
        /*状态*/
        search: '',
        time_date:''
      },
    };
  },
  created() {
    /*获取素材列表*/
    this.getTableList();
  },
  methods: {
    /* 查询*/
    onSubmit() {
      let self = this;
      self.curPage = 1;
      self.loading = true;
      self.getTableList();
    },
    /*获取素材列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      SuggestionApi.suggestionList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加素材*/
    addSuggestion() {
      this.$router.push({
        path: '/plus/suggestion/suggestion/Add'
      });
    },

    /*编辑素材*/
    editSuggestion(row) {
      let params = row.suggestion_id;
      this.$router.push({
        path: '/plus/suggestion/suggestion/Edit',
        query: {
          suggestion_id: params
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getTableList();
    },

    /*删除素材*/
    deleteSuggestion(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          SuggestionApi.suggestionDel(
            {
              suggestion_id: row.suggestion_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },



    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/suggestion/suggestion/Index.vue